import { VIDEO_OBJECT_TYPE } from '../../types'

export const processVideoObjects = (campaign) => {
  const buttonLinks = {}
  const buttonTexts = {}
  const titles = {}
  const subtitles = {}

  if (campaign?.videoObjects) {
    campaign.videoObjects.forEach((vo) => {
      if (vo.type === VIDEO_OBJECT_TYPE.BUTTON) {
        buttonLinks[vo.videoId] = vo.buttonLink
        buttonTexts[vo.videoId] = vo.buttonText
      } else if (vo.type === VIDEO_OBJECT_TYPE.TITLE) {
        titles[vo.videoId] = vo.title
        subtitles[vo.videoId] = vo.subtitle
      }
    })
  }

  return { buttonLinks, buttonTexts, titles, subtitles }
}

export const getWidgetUrlRules = (campaign) => {
  const widgetRuleType0 = campaign && campaign.widgetUrlRules[0] && campaign.widgetUrlRules[0].ruleType
  const widgetRuleUrl0 = campaign && campaign.widgetUrlRules[0] && campaign.widgetUrlRules[0].urlMatch
  const matchType = campaign && campaign.widgetUrlRules[0] && campaign.widgetUrlRules[0].matchType

  return { widgetRuleType0, widgetRuleUrl0, matchType }
}

export const createVideoObjects = (values) => {
  if (!(values.buttonLinks && values.buttonTexts) && !values.titles) {
    return []
  }

  const buttonObjects = Object.keys(values.buttonLinks || {}).map((videoId) => ({
    id: true,
    type: VIDEO_OBJECT_TYPE.BUTTON,
    videoId,
    buttonLink: values.buttonLinks && values.buttonLinks[videoId],
    buttonText: values.buttonTexts && values.buttonTexts[videoId]
  }))

  const titleObjects = Object.keys(values.titles || values.subtitles || {}).map((videoId) => ({
    id: true,
    type: VIDEO_OBJECT_TYPE.TITLE,
    videoId,
    title: values.titles && values.titles[videoId],
    subtitle: values.subtitles && values.subtitles[videoId]
  }))

  return buttonObjects.concat(titleObjects)
}

export const createSelectedVideos = (values, videos, images) => {
  if (!values.videoIds || !videos || !images) {
    return []
  }

  return values.videoIds
    .map((id) => {
      if (videos.find((video) => id === video.id)) {
        return {
          ...videos.find((video) => id === video.id),
          type: 'VIDEO'
        }
      }
      if (images.find((image) => id === image.id)) {
        return {
          ...images.find((image) => id === image.id),
          type: 'IMAGE'
        }
      }
      return null
    })
    .filter((el) => el)
}
